/* eslint-disable import/prefer-default-export */
import React from "react";
import { ComponentContainer as ContainerType } from "../types";

type ContainerProps = {
    children: React.ReactNode | React.ReactNodeArray;
    label?: string;
    dataTestId?: string;
    className?: string;
    component: ContainerType;
    isSelected?: boolean;
    onItemSelect?: (eventData) => void;
};

export function Container({
    children,
    label,
    dataTestId,
    className,
    component,
    isSelected,
    onItemSelect,
}: ContainerProps) {
    const handleClick = evt => {
        if (onItemSelect) {
            onItemSelect({ evt, item: component });
            evt.stopPropagation();
        }
    };
    return (
        // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions,jsx-a11y/click-events-have-key-events
        <div
            role="group"
            data-testid={dataTestId}
            className={`${className}${isSelected ? " selected" : ""}`}
            aria-label={label}
            onClick={handleClick}
        >
            {children}
        </div>
    );
}
